import {create} from "zustand";
import {Contact} from "../interfaces/Contact";
import {Change, status} from "../../../global/interfaces/Change";
import {v4 as uuid} from "uuid";

interface ContactState {
    contacts: Contact[];
    selectedContacts: Contact[];

    currentContact: Contact;
    setCurrentContact: (name: string, isNewEmptyContact?: boolean, suchname?: string) => void
    getContactByName: (name:string) => Contact | undefined;

    removeContact: (name: string) => void;
    addContact: (contact: Contact) => void;
    initContacts: (contacts: Contact[]) => void;

    updateCurrentContactField: (field: keyof Contact, value: any) => void;
    updateContact: (name: string, updatedContact: Contact) => void;

    getContactChanges: () => Change[];
    generateSingleChange: (key: string, changedValue: any, originalValue: any, contactOriginalName: string) => Change;
}

const useContactsStore = create<ContactState>((set, get) => ({
    contacts: [] as Contact[],
    selectedContacts: [] as Contact[],

    getContactByName: (name:string) => get().contacts.find(contact => contact.name === name),

    currentContact: {} as Contact,
    setCurrentContact: (name: string, isNewEmptyContact: boolean = false, suchname?: string) => set((state) => ({
            currentContact: isNewEmptyContact ? {suchname: suchname || ""} as Contact : state.contacts.find(contact => contact.name === name)
        })
    ),
    updateCurrentContactField: (field: keyof Contact, value: any) => set(state => ({
        currentContact: {...state.currentContact, [field]: value}
    })),

    removeContact: (name: string) => set((state) => ({
        contacts: state.contacts.filter(contact => contact.name !== name)
    })),

    addContact: (contact: Contact) => {
        console.log("Contact added: ", contact);
        set((state) => ({
            contacts: [...state.contacts, contact]
        }))
    },

    // Function to set the contacts after the query
    initContacts: (contacts: Contact[]) => set(() => ({
        contacts: [...contacts]
    })),

    // Functions which takes the ID (name) of a contact and updates the state of it
    updateContact: (name: string, updatedContact: Contact) => set(state => ({
        contacts: state.contacts.map(contact => contact.name === name ? updatedContact : contact)
    })),

    generateSingleChange: (key, changedValue, originalValue, contactOriginalName): Change => ({
        datum: new Date().toISOString(),
        feld: key,
        id: uuid(),
        name: contactOriginalName,
        status: status.PENDING,
        suchname: get().currentContact.suchname,
        wertAenderung: changedValue,
        wertOriginal: originalValue
    }),

    getContactChanges: () => {
        const changedContact = get().currentContact
        const originalContact = get().contacts.find(contact => contact.name === changedContact.name)

        const changes: Change[] = []

        if (originalContact) {
            Object.keys(changedContact).forEach(key => {
                if (changedContact[key] !== originalContact[key]) {

                    if (key === "vorname" || key === "nachname" || key === "namensZusatz") {

                        const vorname = changedContact.vorname ? changedContact.vorname : ""
                        const nachname = changedContact.nachname ? changedContact.nachname : ""
                        const namensZusatz = changedContact.namensZusatz ? " " + changedContact.namensZusatz : ""
                        const name = nachname + " " + vorname + namensZusatz

                        get().updateContact(originalContact.name, changedContact)

                        const change: Change = get().generateSingleChange("name", name, originalContact.name, originalContact.name)

                        let changeExists = false;
                        changes.forEach(ch => {
                            if (ch.feld === "name") changeExists = true
                        })
                        if (!changeExists) changes.push(change)

                    } else if (key === "suchname") {

                        console.log("Suchname: ", key)

                    } else {

                        console.log("Rest: ", key)

                        get().updateContact(originalContact.name, changedContact)

                        const change: Change = get().generateSingleChange(key, changedContact[key], originalContact[key], originalContact.name)

                        changes.push(change)

                    }
                }
            });
        } else {
            console.log("There is no such contact in the list: ", changedContact)
            const vorname = changedContact.vorname ? changedContact.vorname : ""
            const nachname = changedContact.nachname ? changedContact.nachname : ""
            const namensZusatz = changedContact.namensZusatz ? " " + changedContact.namensZusatz : ""
            const name = nachname + " " + vorname + namensZusatz
            Object.keys(changedContact).map(key => {
                if (key === "vorname" || key === "nachname" || key === "namensZusatz" || key === "name" || key === "suchname") {
                } else {
                   if (changedContact[key] !== "") changes.push(get().generateSingleChange(key, changedContact[key], "", name))
                }
            })
            changedContact.name = name;
            get().addContact(changedContact)
        }
        return changes;
    }
}))

export default useContactsStore;